import appStore from 'store';
import api from './api';

const store = {

    namespaced: true,

    state: {
        balanceInfo: [],
        billInfo: [],
        balanceSnapInfo:[],
        unFinishOrder: [],
        totalBill: 0,
        totalUnFinishOrder:0
    },


    mutations: {
        setBalanceInfo(state, payload) {
            state.balanceInfo = payload;
        },

        setBillInfo(state, payload) {
            state.billInfo = payload;
        },

        setBalanceSnapInfo(state,payload) {
            state.balanceSnapInfo = payload;
        },

        setUnFinishOrder(state,payload) {
            state.unFinishOrder = payload;
        },

        setTotalBill(state,payload) {
            state.totalBill = payload;
        },
        setTotalUnFinishOrder(state,payload) {
            state.totalUnFinishOrder = payload;
        }
    },

    actions: {

        /**获取余额信息*/
        getBalanceInfo({commit}, data) {
            return api.getBalance(data).then(response => {
                commit('setBalanceInfo',response.data);
            })
        },

        /**获取用户当前账单信息*/
        getBillInfo({commit}, data) {
            api.getBill(data).then(response => {
                commit('setBillInfo', response.data.bill);
                commit('setTotalBill',response.data.count);
            })
        },

        /**获取快照余额信息*/
        getSnapBalanceInfo({commit},data) {
          api.getSnapBalance(data).then(response => {
              commit('setBalanceSnapInfo',response.data);
          })
        },

        /**重置账单*/
        setBalance({commit}, data) {
            return api.reSetBalance(data);
        },

        /** 获取用户未完成的订单，通过交易对*/
        queryUnFinishOrder({commit},data) {
            api.getUnFinishOrder(data).then( response => {
                commit('setUnFinishOrder',response.data.data);
                commit('setTotalUnFinishOrder',response.data.total)
            })
        },

        cancelUserOrder({commit},data) {
            return api.cancelOrder(data);
        }
    },

}

appStore.registerModule('tradeException', store);